import { UseFormReturn } from 'react-hook-form'

import { SavingsWithdrawDialogForm } from '../components/form/SavingsWithdrawDialogForm'
import { TransactionOverview } from '../components/transaction-overview/TransactionOverview'
import { SavingsWithdrawTxOverview, SendModeExtension } from '../types'
import { TokenWithBalance } from '@/domain/common/types'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'
import { AssetInputRenderError } from '@/ui/organisms/asset-input/AssetInput'

export interface SavingsWithdrawViewProps {
  accountName: string
  selectableAssets: TokenWithBalance[]
  assetsFields: FormFieldsForDialog
  form: UseFormReturn<AssetInputSchema>
  txOverview: SavingsWithdrawTxOverview
  actionsViewState: ActionsViewState
  sendModeExtension?: SendModeExtension
  renderError?: AssetInputRenderError
}

export function SavingsWithdrawView({
  accountName,
  selectableAssets,
  assetsFields,
  form,
  txOverview,
  actionsViewState,
  sendModeExtension,
  renderError,
}: SavingsWithdrawViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>{`${sendModeExtension ? 'Send' : 'Withdraw'} from ${accountName}`}</DialogTitle>

      <FormAndOverviewWrapper>
        <SavingsWithdrawDialogForm
          form={form}
          sendModeExtension={sendModeExtension}
          assetsFields={assetsFields}
          selectorAssets={selectableAssets}
          renderError={renderError}
        />
        <TransactionOverview txOverview={txOverview} />
      </FormAndOverviewWrapper>

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
